const apiEndPoints = {
  baseCommonProductAPI: `/rest/v0.1`,
  getDMSConnectionInfo: `/rest/v0.1/featureInstanceMetadata/search.json?productCode=GY_INT&versionIdenfier=v1.0&featureCodes=Xml_EOAPI,Xml_Apache,postgres_adpreport&orgUnitId=`,
  putRefreshIPAddressDetails: '/rest/v0.1/orgUnit/metadata.json',
  getStoresPackageEnablementInfo: (
    packageId: string,
    enterpriseId: string
  ): string =>
    `/rest/v0.1/packages/${packageId}/enablementInfo?enterpriseId=${enterpriseId}`,
  getPackagesByStoreId: `/rest/v0.1/packageInstances/search.json?orgUnitId=`,
  postMultiStoreEnablement: '/rest/v0.1/packageInstances/multiStoreEnablement'
};

export default apiEndPoints;
